/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDatabaseRoleBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 21"
    fill="none"
    {...props}
  >
    <path
      d="M14.5 4.1875C14.5 6.08598 11.422 7.625 7.625 7.625C3.82804 7.625 0.75 6.08598 0.75 4.1875M14.5 4.1875C14.5 2.28902 11.422 0.75 7.625 0.75C3.82804 0.75 0.75 2.28902 0.75 4.1875M14.5 4.1875V7.3125M0.75 4.1875V13.5625C0.75 15.461 3.125 16.875 6.125 16.875M0.75 4.1875V7.3125M6.125 13.5625C4.125 13.5625 0.75 12.336 0.75 10.4375V7.3125M0.75 7.3125C0.75 9.21098 3.82804 10.75 7.625 10.75M14.8753 12.6058C14.8753 13.5616 14.0916 14.3365 13.125 14.3365C12.1584 14.3365 11.3747 13.5616 11.3747 12.6058C11.3747 11.6499 12.1584 10.875 13.125 10.875C14.0916 10.875 14.8753 11.6499 14.8753 12.6058ZM9.625 19.1219C9.65781 17.2382 11.2122 15.7212 13.125 15.7212C15.0378 15.7212 16.5923 17.2383 16.625 19.122C15.5595 19.6055 14.3742 19.875 13.1251 19.875C11.876 19.875 10.6905 19.6054 9.625 19.1219Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDatabaseRole = wrapIcon(SvgDatabaseRoleBase);
export default SvgDatabaseRole;
